export default __webpack_public_path__ + "static/media/error.ae988b3c.mp3";